
export const colors = {
  black: '#000',
  grey1: '#1A1A1A',
  grey5: '#555555',
  grey6: '#666666',
  grey14: '#E6E6E6',
  white: '#fff',

  screenTeal: '#446C55',
  screenTealLight: '#C0D9CC',

  screenError: '#7D241E',

  darkBlue: '#201D3E',
  blue: '#00538A',
  franklin: '#0071BC',
  accent: '#F73404',
  eggShell: '#F6F3EB',
};

export const fonts = {
  vcr: 'VCR OSD Mono',
  nunito: "'Nunito', sans-serif",
};

export const fontWeight = {
  regular: 400,
  bold: 700,
  extraBold: 800,
};
